import Vue from 'vue'
import VueRouter from 'vue-router'
import {ability} from '../services/ability'
import { AbilityBuilder, Ability } from '@casl/ability'
const { can, cannot, build } = new AbilityBuilder(Ability)

const Dashboard = () => import('../components/Dashboard.vue' /* webpackChunkName: "src/components/Dashboard" */)
// POS
const POS = () => import('../components/views/Pos.vue' /* webpackChunkName: "src/components/views/Pos" */)
const Receipt = () => import('../components/receipts/index.vue' /* webpackChunkName: "src/components/receipts/index" */)
const Profile = () => import('../components/profile/index.vue' /* webpackChunkName: "src/components/profile/index" */)
// products
const ProductList = () => import('../components/products/index.vue' /* webpackChunkName: "src/components/products/index" */)
// categories
const CategoryList = () => import('../components/categories/index.vue' /* webpackChunkName: "src/components/categories/index" */)
// discounts
const DiscountList = () => import('../components/discounts/index.vue' /* webpackChunkName: "src/components/discounts/index" */)
// taxes
const TaxList = () => import('../components/taxes/index.vue' /* webpackChunkName: "src/components/taxes/index" */)
// stores
const StoreList = () => import('../components/stores/index.vue' /* webpackChunkName: "src/components/stores/index" */)
// reports
const SalesSummary = () => import('../components/reports/sales_summary/index.vue' /* webpackChunkName: "src/components/reports/sales_summary/index" */)
const SalesItem = () => import('../components/reports/sales_item/index.vue' /* webpackChunkName: "src/components/reports/sales_item/index" */)
const SalesCategory = () => import('../components/reports/sales_category/index.vue' /* webpackChunkName: "src/components/reports/sales_category/index" */)

const Login = () => import('../components/views/Login.vue' /* webpackChunkName: "src/components/views/Login" */)
const Signup = () => import('../components/views/Signup.vue' /* webpackChunkName: "src/components/views/Signup" */)

const ForgotPassword = () => import('../components/views/forgotpassword.vue' /* webpackChunkName: "src/components/views/forgotpassword" */)
const ResetPasswordForm = () => import('../components/views/resetpassword.vue' /* webpackChunkName: "src/components/views/resetpassword" */)

const usersList = () => import('../components/config/users.vue' /* webpackChunkName: "src/components/config/users" */)
const roleList = () => import('../components/config/roles.vue' /* webpackChunkName: "src/components/config/roles" */)
const permissionList = () => import('../components/config/permissions.vue' /* webpackChunkName: "src/components/config/permissions" */)


Vue.use(VueRouter)

 const routes = [
 { 
    path: '/forgot/password', 
    name: 'ForgotPassword', 
    component: ForgotPassword, 
    meta: {
      auth: undefined
    }
  },
  { 
    path: '/reset/:token', 
    name: 'ResetPasswordForm', 
    component: ResetPasswordForm, 
    meta: {
      auth: undefined
    } 
  },
 {
    path: '/reports/sales-summary',
    name: 'salesSummary',
    component: SalesSummary,
    meta: {
      auth: true
    }
  },
  {
    path: '/reports/sales-item',
    name: 'salesItem',
    component: SalesItem,
    meta: {
      auth: true
    }
  },
  {
    path: '/reports/sales-category',
    name: 'salesCategory',
    component: SalesCategory,
    meta: {
      auth: true
    }
  },
  {
    path: '/account/profile',
    name: 'Profile',
    component: Profile,
    meta: {
      auth: true
    }
  },
  {
    path: '/point-of-sale',
    name: 'Pos',
    component: POS,
    meta: {
      auth: true
    }
  },
  {
    path: '/sales/receipts',
    name: 'Receipt',
    component: Receipt,
    meta: {
      auth: true
    }
  },
  {
    path: '/',
    name: 'Dashboard',
    component: Dashboard,
    meta: {
      auth: true
    }
  },
  {
    path: '/auth/login',
    name: 'Login',
    component: Login,
    meta: {
      auth: undefined
    }
  },
  {
    path: '/auth/register',
    name: 'Signup',
    component: Signup
  },
  {
      name: 'productList',
      path: '/products/list',
      component: ProductList,
      meta: {
        auth: true
      }
  },
  {
      name: 'categoryList',
      path: '/category/list',
      component: CategoryList,
      meta: {
        auth: true
      }
  },
  {
      name: 'discountList',
      path: '/discount/list',
      component: DiscountList,
      meta: {
        auth: true
      }
  },
  {
      name: 'taxList',
      path: '/tax/list',
      component: TaxList,
      meta: {
        auth: true
      }
  },
  {
      name: 'storeList',
      path: '/store/list',
      component: StoreList,
      meta: {
        auth: true
      }
  },
  // users
  {
      name: 'usersList',
      path: '/users/list',
      component: usersList,
      meta: {
        auth: true
      }
  },
  {
      name: 'roleList',
      path: '/role/list',
      component: roleList,
      meta: {
        auth: true
      }
  },
  {
      name: 'permissionList',
      path: '/permission/list',
      component: permissionList,
      meta: {
        auth: true
      }
  }
]

const router = new VueRouter({
  mode: 'history',
  routes
})

router.beforeEach((to, from, next) => {
  const loggedIn = localStorage.getItem('user')

  if (to.matched.some(record => record.meta.auth) && !loggedIn) {
    next('/auth/login')
    return
  }else {
    next()
  }
  
})

export default router
